import React, { useRef, useState } from 'react';
import { useClickAway } from 'react-use';
import { MenuContainer, MenuContent, MenuOpenButton } from './Menu.styles';
import SvgMenu from '../../../../play-core/icons/Menu';
import { colorSets } from '../ClickableComponents/styles';
import { RemixFocusLock } from '../ClientOnly/ClientOnly';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const interactiveElements = ['button', 'a'];
export const Menu = ({
  children,
  icon = /*#__PURE__*/_jsx(SvgMenu, {}),
  ariaLabel,
  ariaLabelOpen,
  iconSize,
  colorSet = colorSets.transparent,
  iconIndicator
}) => {
  const [isOpen, setOpen] = useState(false);
  const menuRef = useRef(null);
  useClickAway(menuRef, () => setOpen(false));
  const hasContent = React.Children.count(children) > 0;
  return /*#__PURE__*/_jsx(RemixFocusLock, {
    disabled: !isOpen,
    children: hasContent && /*#__PURE__*/_jsxs(MenuContainer, {
      ref: menuRef,
      onKeyDown: event => {
        // Close with Escape key
        if (event.keyCode === 27) {
          setOpen(false);
        }
      },
      onClick: event => {
        const clickedElement = findClickedElementWithinMenu(event.target, menuRef?.current);
        if (clickedElement === 'button') {
          setOpen(false);
          event.preventDefault();
        } else if (clickedElement === 'a') {
          setOpen(false);
        }
      },
      children: [/*#__PURE__*/_jsx(MenuOpenButton, {
        type: "icon",
        size: "small",
        icon: icon,
        iconSize: iconSize,
        ariaLabel: isOpen ? ariaLabelOpen || ariaLabel : ariaLabel,
        isActive: isOpen,
        onClick: e => {
          e?.preventDefault();
          e?.stopPropagation();
          setOpen(!isOpen);
        },
        colorSet: colorSet,
        iconIndicator: iconIndicator,
        multilineText: true
      }), isOpen && /*#__PURE__*/_jsx(MenuContent, {
        children: children
      })]
    })
  });
};
const findClickedElementWithinMenu = (element, menuElement) => {
  if (interactiveElements.map(s => s.toLowerCase()).includes(element.tagName.toLowerCase())) {
    return element.tagName.toLowerCase();
  }
  if (element === menuElement) {
    return 'menu';
  }
  if (element.parentElement) {
    return findClickedElementWithinMenu(element.parentElement, menuElement);
  }
  return 'other';
};